// Improved PopUpDialog with enhanced mobile fullscreen, spacing, slide animation, and clean UI
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DialogTitle from '@mui/material/DialogTitle';
import RegisterForm from './RegisterForm';
import { ContextData } from '../../context/Context';
import axios from 'axios';
import baseUrl from '../../BaseURL';
import ApplicantLogin from './ApplicantLogin';
import { toast } from 'react-toastify';
import SoundAlert from '../../routes/SoundAlert';
import { useMediaQuery, useTheme, Slide } from '@mui/material';

export default function PopUpDialug() {


  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const [QualificationList, setQualificationList] = React.useState(null);
  const { AdministratorTokens } = React.useContext(ContextData);
  const [changeform, setchangeform] = React.useState('home');
  const [ISAccount, setISAccount] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Slide animation
  const Transition = React.useCallback(
    React.forwardRef(function Transition(props, ref) {
      return <Slide direction="up" ref={ref} {...props} />;
    }),
    []
  );

  React.useEffect(() => {
    async function FetchData() {
      try {
        const response = await axios.get(`${baseUrl}/auth/get_amount`, {
          withCredentials: true,
          headers: {
            Accept: 'application/json',
            authorization: `Bearer ${AdministratorTokens !== null && AdministratorTokens}`,
          },
        });

        setQualificationList(response.data);
      } catch (err) {
        if (err) console.log(err.message);
      }
    }
    FetchData();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (ISAccount) {
      toast.success('Account Created');
      SoundAlert('success');
    }
  }, [ISAccount]);

  return (
    <React.Fragment>
      <Button variant="contained" sx={{ fontSize: '1.5em', color: 'wheat', mb: '4em' }} onClick={handleClickOpen}>
        LOGIN/APPLY NOW
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        id="dia-log-con-sign-login"
        PaperProps={{
          sx: {
            width: isMobile ? '100% !important' : '600px',
            height: isMobile ? '100% !important' : 'auto',
            maxWidth: isMobile ? '100% !important' : '600px',
            margin: isMobile ? 0 : undefined,
            borderRadius: isMobile ? 0 : '12px',
            p: 0,
          },
        }}
      >
        <div className="flex justify-between items-center px-4 pt-3">
          <DialogTitle sx={{ p: 0, fontWeight: 'bold' }}>
            {changeform === 'home' && 'KADSSLB'}
            {changeform === 'login' && 'Login'}
            {changeform === 'signup' && 'Sign Up'}
          </DialogTitle>

          <img
            src={
              changeform === 'signup'
                ? './assets/newksslb.jpg'
                : './assets/dbimgs/kd.png'
            }
            className="w-14 shadow-xl"
          />
        </div>

        <DialogContent dividers={scroll === 'paper'} sx={{ p: isMobile ? 0 : 2 }}>
          <div className="w-full flex justify-center items-center py-6">
            {changeform === 'home' && (
              <div className="flex flex-col w-full px-4 max-w-sm">
                <img src="./assets/newksslb.jpg" className="w-40 mx-auto mb-4" />

                <Button onClick={() => setchangeform('signup')} sx={{ width: '100%', mb: 2 }} variant="contained">
                  <span className="font-extrabold">Create Account</span>
                </Button>

                <span className="font-extrabold text-center">
                  <AutorenewIcon />
                </span>

                <Button onClick={() => setchangeform('login')} sx={{ width: '100%', mt: 2 }} variant="contained">
                  <span className="font-extrabold">Login</span>
                </Button>
              </div>
            )}

            {changeform === 'signup' && (
              <RegisterForm QualificationList={QualificationList} setchangeform={setchangeform} setISAccount={setISAccount} />
            )}

            {changeform === 'login' && <ApplicantLogin QualificationList={QualificationList} />}
          </div>
        </DialogContent>

        <DialogActions sx={{ px: 2, py: 1 }}>
          <div className="flex w-full justify-between items-center">
            {changeform !== 'home' && (
              <Button onClick={() => setchangeform('home')} variant="contained" color="primary" sx={{ mb: 1 }}>
                <ArrowBackIcon />
              </Button>
            )}

            <h3 className="text-lg font-extrabold">Progressive Form</h3>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}